import LogsTableRow from './LogsTableRow';

export default LogsTableRow;


// WEBPACK FOOTER //
// ./src/features/log/components/logs-table/logs-table-row/index.js